module.exports = __webpack_public_path__ + "static/media/animo.7a1bc4bc.png";